








































































import { Component, Prop, Watch, Model, Mixins } from 'vue-property-decorator';
import parseUrl from 'parse-url';
import CustomDialog from '@/components/tools/CustomDialog.vue';
import VerifyMixin from '@/assets/ts/mixins/VerifyMixin';
import MobileDetectionMixin from '@/assets/ts/mixins/MobileDetectionMixin';
import NoScanner from '@/components/scanner/NoScanner.vue';
import CertificateInformation from '@/components/certificate/CertificateInformation.vue';
import Illustration from '@/components/tools/dialogscanner/Illustration.vue';
import DesktopScanner from '@/components/tools/dialogscanner/DesktopScanner.vue';
import DialogMobileScanner from '@/components/tools/dialogscanner/DialogMobileScanner.vue';
import FakeAsset from '@/components/tools/dialogscanner/FakeAsset.vue';
import { IAssetInfo } from '@/store/modules/asset/interface';
import { EventBus } from '@/plugins/event-bus';

// const NoScanner = () => import('@/components/scanner/NoScanner.vue');

@Component({
  components: {
    NoScanner,
    CustomDialog,
    DesktopScanner,
    DialogMobileScanner,
    CertificateInformation,
    FakeAsset,
    Illustration,
  },
})
export default class Verify extends Mixins(VerifyMixin, MobileDetectionMixin) {
  // Dialog property
  public headerTitle = '';
  public contentHeight = '300px';

  // Action Button Property
  public rightButtonShow = false;
  public rightButtonLabel = 'Cancel';
  public leftButtonShow = false;
  public leftButtonLabel = 'Ok';

  @Prop({ default: false }) public open!: boolean;

  // show: indicator to show verifier dialog
  public show = this.open;

  // view: indicator to change the content
  public view = 'illustration';

  // showMobileScanner: indicator to show mobile scanner dialog
  public showMobileScanner = false;

  public buttonNoScannerIsLoading = false;

  public assetPubAccount: null | any = null;

  public assetFirstImg = '';


  @Watch('open')
  public onOpenChange(val: boolean) {
    this.show = val;
    if (val) {
      // every time it's open it will always open illustration
      this.view = 'illustration';
    }
  }

  @Watch('show')
  public onShowChange(val: boolean) {
    if (!val) {
      // if it close then
      // emit to parent component to change the prop
      this.$emit('update:open', false);
    }
  }

  public changeView(view: string) {
    this.view = view;
    if (this.isMobile) {
      this.showMobileScanner = false;
    }
  }

  public showScanner() {
    if (this.isMobile) {
      // show mobile scanner
      this.showMobileScanner = true;
    } else {
      // show desktop scanner
      this.changeView('scanner');
    }
  }

  public async onDecode(decode: any, isScanner = true) {
    // Button Scanner Start Loading
    this.buttonNoScannerIsLoading = true;

    const whiteList = [
      'localhost',
      'luxtagofficial.now.sh',
      'luxtag.io'
    ];

    try {
      const url = parseUrl(decode);
      const isWhiteListed = whiteList.some((wl) => url.resource.indexOf(wl) !== -1);
      if (isWhiteListed) {
        window.open(decode, '_self');
      } else {
        throw new Error('URL not whitelisted');
      }
    } catch (e) {
      console.log('[Error] onDecode', e);
      this.$router.push('/404');
    }

    // // Start processing the decode
    // const isVerified = await this.verify(decode);
    // if (isVerified) {
    //   this.assetPubAccount = {};
    //   // verified
    //   this.changeView('found-authentic-product');
    // } else {
    //   // not verified
    //   EventBus.$emit('show-error', 'Asset does not exist');
    // }

    // Button Scanner Stop Loading
  }


  public onRightActionButtonClicked() {
    if (this.view === 'illustration') {
      this.showScanner();
    } else if (this.view === 'scanner') {
      // do nothing because the button does not show up
    } else if (this.view === 'no-scanner') {
      // do nothing because the button does not show up
    } else if (this.view === 'found-authentic-product') {
      this.show = false;
    } else if (this.view === 'found-fake-product') {
      this.show = false;
    } else {
      this.headerTitle = 'We have not specified the title yet';
    }
  }

  public onLeftActionButtonClicked() {
    if (this.view === 'illustration') {
      // do nothing because the button does not show up
    } else if (this.view === 'scanner') {
      // do nothing because the button does not show up
    } else if (this.view === 'no-scanner') {
      // do nothing because the button does not show up
    } else if (this.view === 'found-authentic-product') {
      // do nothing because the button does not show up
    } else if (this.view === 'found-fake-product') {
      // do nothing because the button does not show up
    } else {
      this.headerTitle = 'We have not specified the title yet';
    }
  }

  @Watch('view', { immediate: true, deep: true })
  private onViewChanged(val: string, oldVal: string) {
    if (this.view === 'illustration') {

      this.headerTitle = 'You are about to verify a product';
      this.contentHeight = '500px';

      this.leftButtonShow = false;
      this.rightButtonShow = true;
      this.rightButtonLabel = 'Scan now';

    } else if (this.view === 'scanner') {
      this.headerTitle = 'Scan Certificate QR Code';
      this.contentHeight = '440px';

      this.leftButtonShow = false;
      this.rightButtonShow = false;
    } else if (this.view === 'no-scanner') {
      this.headerTitle = 'You are about to authenticate a product';
      this.contentHeight = '180px';

      this.leftButtonShow = false;
      this.rightButtonShow = false;

      this.buttonNoScannerIsLoading = false;
    } else if (this.view === 'found-authentic-product') {
      this.headerTitle = 'You found an authentic product';
      this.contentHeight = '570px';

      this.leftButtonShow = false;
      this.rightButtonShow = true;
      this.rightButtonLabel = 'Ok';
    } else if (this.view === 'found-fake-product') {
      this.headerTitle = 'You found a counterfeit product';
      this.leftButtonShow = false;
      this.rightButtonShow = true;
      this.rightButtonLabel = 'OK';
    } else {
      this.headerTitle = 'We have not specified the title yet';
    }
  }

}
